import { type FormikValues, validateYupSchema, yupToFormErrors } from 'formik';
import type { Schema } from 'yup';

/**
 * Takes a factory rather than a schema so the schema is constructed per
 * validation. The schemas carry translated labels and messages, and building one
 * at module scope resolves those before i18next has been initialised, baking the
 * raw keys into the form errors.
 */
export const createGetValidator =
  (getSchema: () => Schema) =>
  (context = {}) =>
  // field is optional so the produced validator matches Formik's
  // `validate: (values) => ...` signature (Formik calls it with one arg)
  (values: FormikValues, field?: string) => {
    const schema = getSchema();

    return Promise.resolve(
      field
        ? schema.validateAt(field, values, { context })
        : validateYupSchema(values, schema, false, context)
    )
      .then(() => ({}))
      .catch(error =>
        error.name === 'ValidationError'
          ? yupToFormErrors(error)
          : Promise.reject(error)
      );
  };
